<div class="flex flex-col mt-5">
  <!-- todo: is wierd -->
  <!--h6 class="font-semibold text-light text-sm mb-1 uppercase leading-wide tracking-wide">
    {{ '#ARTIKELINFO.PAGES.DETAIL.PRICES.TITLE' | translate }}
  </h6-->
  <soft-ds-card density="none">
    <cdk-accordion class="flex flex-col" [multi]="true">
      @for ( stockEntry of data()?.tieredPricelist || []; track stockEntry; let i = $index
      ) {
      <cdk-accordion-item
        #accordionItem="cdkAccordionItem"
        [expanded]="true"
        [attr.id]="'accordion-header-' + i"
        [attr.aria-expanded]="accordionItem.expanded"
        [attr.aria-controls]="'accordion-body-' + i"
        class="flex flex-col"
      >
        <div
          class="flex justify-between items-center cursor-pointer p-4"
          role="button"
          tabindex="0"
          (click)="accordionItem.toggle()"
          (keydown.enter)="accordionItem.toggle()"
          (keydown.space)="$event.preventDefault(); accordionItem.toggle()"
        >
          <span
            class="font-semibold text-light text-sm uppercase leading-wide tracking-wide"
          >
            {{ stockEntry?.priceLevel?.title }}
            <soft-ds-badge size="md" variant="outline">
              {{ stockEntry?.tieredPrices?.length }}
            </soft-ds-badge>
          </span>

          <div
            class="text-light bg-surface rounded-full p-3 cursor-pointer hover:bg-hover"
          >
            @if (!accordionItem.expanded) {
            <soft-icon name="fa-regular fa-chevron-down" />
            } @if (accordionItem.expanded) {
            <soft-icon name="fa-regular fa-chevron-up" />
            }
          </div>
        </div>
        <div
          [style.display]="accordionItem.expanded ? 'block' : 'none'"
          class="pt-2 bg-surface"
        >
          <div
            class="grid grid-cols-4 items-center gap-1 w-full px-4 py-2 border-t border-t-solid border-t-separator bg-surface-tertiary"
          >
            <div class="text-xs font-semibold text-light uppercase">
              {{ '#ARTIKELINFO.PAGES.DETAIL.PRICES.AMOUNT' | translate }}
            </div>
            <div class="text-xs font-semibold text-light uppercase">
              {{ '#ARTIKELINFO.PAGES.DETAIL.PRICES.UNIT' | translate }}
            </div>
            <div class="text-xs font-semibold text-light uppercase">
              {{ '#ARTIKELINFO.PAGES.DETAIL.PRICES.PER' | translate }}
            </div>
            <div class="text-xs font-semibold text-light uppercase text-right">
              {{ '#ARTIKELINFO.PAGES.DETAIL.PRICES.PRICE' | translate }}
            </div>
          </div>
          @for ( tierPrice of stockEntry.tieredPrices; track tierPrice; let last = $last )
          {
          <div
            class="grid grid-cols-4 gap-1 w-full px-4 py-3 border-t border-t-solid border-t-separator"
          >
            <span class="text-sm md:text-base">{{ tierPrice.amount }}</span>
            <span class="text-sm md:text-base">{{ tierPrice.unit.name }}</span>
            <span class="text-sm md:text-base">{{ tierPrice?.priceUnit ?? 1 }}</span>
            <span class="text-sm md:text-base text-right">
              {{ tierPrice.gross ?? 0 | currency: tierPrice.currency : 'symbol-narrow' :
              '1.2-4' }}
            </span>
          </div>
          }
        </div>
      </cdk-accordion-item>
      }
    </cdk-accordion>

    @if ( data()?.discountTieredPricelist && (data()?.discountTieredPricelist ||
    []).length > 0 && ((data()?.discountTieredPricelist ?? [])[0]?.discountTieredPrices
    ?.length ?? 0) > 0 ) {
    <cdk-accordion class="flex flex-col" [multi]="true">
      @for ( stockEntry of data()?.discountTieredPricelist || []; track stockEntry; let i
      = $index ) {
      <cdk-accordion-item
        #accordionItem="cdkAccordionItem"
        [expanded]="true"
        [attr.id]="'accordion-header-' + i"
        [attr.aria-expanded]="accordionItem.expanded"
        [attr.aria-controls]="'accordion-body-' + i"
        class="flex flex-col w-full border-b border-b-solid border-b-separator"
      >
        <div
          class="flex items-center justify-between bg-danger-100 cursor-pointer p-4"
          role="button"
          tabindex="0"
          (click)="accordionItem.toggle()"
          (keydown.enter)="accordionItem.toggle()"
          (keydown.space)="$event.preventDefault(); accordionItem.toggle()"
        >
          <div class="flex items-center gap-2">
            <span
              class="font-semibold text-light text-sm uppercase leading-wide tracking-wide"
              [innerHTML]="
                          stockEntry?.discount?.title || stockEntry?.discount?.name
                        "
            ></span>
          </div>
          <div
            class="text-light bg-surface rounded-full p-3 cursor-pointer hover:bg-hover"
          >
            @if (!accordionItem.expanded) {
            <soft-icon name="fa-regular fa-chevron-down" />
            } @if (accordionItem.expanded) {
            <soft-icon name="fa-regular fa-chevron-up" />
            }
          </div>
        </div>
        <div
          [style.display]="accordionItem.expanded ? 'block' : 'none'"
          class="pt-2 bg-surface"
        >
          <div
            class="g gtc-4 gap-1 w-full px-4 py-2 border-t border-t-solid border-t-separator bg-surface-tertiary"
          >
            <div class="text-xs font-semibold text-light uppercase">
              {{ '#ARTIKELINFO.PAGES.DETAIL.PRICES.AMOUNT' | translate }}
            </div>
            <div class="text-xs font-semibold text-light uppercase">
              {{ '#ARTIKELINFO.PAGES.DETAIL.PRICES.UNIT' | translate }}
            </div>
            <div class="text-xs font-semibold text-light uppercase">
              {{ '#ARTIKELINFO.PAGES.DETAIL.PRICES.PER' | translate }}
            </div>
            <div class="text-xs font-semibold text-light uppercase text-right">
              {{ '#ARTIKELINFO.PAGES.DETAIL.PRICES.PRICE' | translate }}
            </div>
          </div>
          @for ( tierPrice of stockEntry.discountTieredPrices; track tierPrice; let last =
          $last ) {
          <div
            class="g gtc-4 gap-1 w-full px-4 py-3 border-t border-t-solid border-t-separator bg-success-100"
          >
            <span class="text-sm md:text-base">{{ tierPrice.amount }}</span>
            <span class="text-sm md:text-base">{{ tierPrice.unit.name }}</span>
            <span class="text-sm md:text-base">{{ tierPrice?.priceUnit ?? 1 }}</span>
            <div
              class="flex text-sm md:text-base text-right"
              [ngClass]="
                            tierPrice.gross === 0
                              ? 'items-center justify-end'
                              : 'flex-col justify-center items-end'
                          "
            >
              @if (tierPrice.gross !== 0) {
              <span class="font-semibold text-sm md:text-base text-right">
                {{ tierPrice.gross ?? 0 | currency: tierPrice.currency }}
              </span>
              } @if ( tierPrice?.discountPercentage &&
              (tierPrice?.discountPercentage?.length ?? 0) > 0 ) {
              <div class="flex items-center">
                <ng-container>
                  @for ( percentage of tierPrice.discountPercentage; track percentage; let
                  last = $last ) {
                  <span
                    class="text-right text-sm md:text-base"
                    [ngClass]="
                                      tierPrice.gross === 0
                                        ? 'font-semibold flex gap-1'
                                        : 'font-normal text-xs text-light flex gap-1'
                                    "
                  >
                    {{ percentage | number: '1.2-2' }}% @if (!last) { &nbsp;+&nbsp; }
                  </span>
                  }
                </ng-container>
              </div>
              }
            </div>
          </div>
          }
        </div>
      </cdk-accordion-item>
      }
    </cdk-accordion>
    }
  </soft-ds-card>
</div>
